<template>
  <div>
    <div v-show="showTitle"
         class="text-md font-bold text-text leading-8 mb-4">{{ title }}
    </div>
    <div v-if="loading && !templates.length" class="flex justify-center">
      <font-awesome-icon class="text-center text-lg text-primary" icon="circle-notch" spin/>
    </div>
    <template v-else>
      <PlannedTransactionViewTemplate v-for="(template,i) in templates" :key="i"
                                      :template="template"
                                      @edit="$emit('edit',template)"
                                      @delete="$emit('delete',template.id)"/>
    </template>
  </div>
</template>

<script>
import PlannedTransactionViewTemplate
  from "@/components/common/PlannedTransaction/PlannedTransactionView/PlannedTransactionViewTemplate";

export default {
  name: "TransactionsTemplatesList",
  components: {PlannedTransactionViewTemplate},
  props: {
    title: {
      type: String
    },
    templates: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    showTitle() {
      return this.title
          && (!this.loading && this.templates.length)
          || this.loading

    }
  }
}
</script>